<template>
    <v-card>
        <v-card-title class="justify-center" style="font-size: 1.5em;">
            {{titulo}}
        </v-card-title>
        <v-card-actions class="justify-space-around">
            <v-btn
                round
                :color="cor2"
                small
                @click="$emit('negado')"
                class="mb-2"
            >
                Não
            </v-btn>
            <v-btn
                round
                :color="cor"
                small
                @click="$emit('aceito')"
                class="mb-2"
            >
                Sim
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    props: ['titulo', 'cor', 'cor2']
}
</script>
